import { tv, type VariantProps } from "tailwind-variants";

export const spinnerVariants = tv({
	base: "inline-block animate-spin",
	variants: {
		size: {
			xs: "h-3 w-3",
			sm: "h-4 w-4",
			md: "h-6 w-6",
			lg: "h-8 w-8",
			xl: "h-10 w-10",
			"2xl": "h-12 w-12",
		},
		color: {
			white: "text-white",
			black: "text-default",
			inherit: "",
		},
	},
	defaultVariants: {
		size: "md",
	},
});

export type SpinnerVariant = VariantProps<typeof spinnerVariants>;

export interface SpinnerProps extends SpinnerVariant {
	readonly className?: string;
	readonly "aria-label"?: string;
}

export function Spinner({
	size = "md",
	color = "black",
	className,
	"aria-label": ariaLabel = "Loading",
}: SpinnerProps) {
	return (
		<span role="status" className={spinnerVariants({ size, color, className })}>
			<svg
				viewBox="0 0 100 100"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				aria-hidden="true"
			>
				<circle
					cx="50"
					cy="50"
					r="40"
					// 90% Spinner usages are with currentColor (text color)
					// If needed a special color, change font color with className prop
					stroke="currentColor"
					strokeWidth="8"
					strokeLinecap="round"
					fill="none"
					strokeDasharray="188.5 251.3"
					strokeDashoffset="0"
				/>
			</svg>
			<span className="sr-only">{ariaLabel}</span>
		</span>
	);
}
